import * as React from 'react';
import { Grid, Input, FormControl, TextField, Select, MenuItem, Button, InputLabel } from '@material-ui/core';
import * as moment from 'moment';
let min =  new Date().getFullYear();
const max = min + 5;

export default class SurveyDetailsComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleDeadlineDateChange = this.handleDeadlineDateChange.bind(this);
        this.getMenuItem = this.getMenuItem.bind(this);
        this.updateSurveyEndDate = this.updateSurveyEndDate.bind(this);
    }

    handleTitleChange = (event: any) => {
        const BaseSurvey: any = this.props.baseSurvey;
        BaseSurvey.title = event.target.value;
        this.props.handleSurveyDetailsChange(BaseSurvey);
    }

    handleYearChange = (event: any) => {
        const BaseSurvey: any = this.props.baseSurvey;
        BaseSurvey.year = event.target.value;
        this.props.handleSurveyDetailsChange(BaseSurvey);
    }

    handleSurveyTypeChange = (event: any) => {
        const BaseSurvey: any = this.props.baseSurvey;
        BaseSurvey.surveyType = event.target.value;
        this.props.handleSurveyDetailsChange(BaseSurvey);
    }

    handleDescriptionChange = (event: any) => {
        const BaseSurvey: any = this.props.baseSurvey;
        BaseSurvey.description = event.target.value;
        this.props.handleSurveyDetailsChange(BaseSurvey);
    }

    handleDeadlineDateChange = (event: any) => {
        const BaseSurvey: any = this.props.baseSurvey;
        BaseSurvey.deadlineDate = event.target.value;
        this.props.handleSurveyDetailsChange(BaseSurvey);
    }

    getMenuItem() {
        const menuItemArray: any = [];
        for (let i = min; i <= max; i++) {
            menuItemArray.push(<MenuItem value={i} key={i}>{i}</MenuItem>)
        }
        return menuItemArray;
    }

    updateSurveyEndDate() {
        this.props.updateSurveyEndDate()
    }

    render() {
        let validationDate: any;
        if (this.props.baseSurvey && this.props.baseSurvey.deadlineDate) {
            validationDate = moment(this.props.baseSurvey.deadlineDate, "YYYY-MM-DD");
            validationDate = validationDate.format("YYYY-MM-DD");
        }
        const status = (this.props.baseSurvey ? (this.props.baseSurvey.status === 2 ? true : false) : false);

        min = this.props.baseSurvey.year !== null ? this.props.baseSurvey && this.props.baseSurvey.year || '' : min;
            
        return (
            <>
                {this.props.baseSurvey &&
                    <div className="pageSurveyTopSection">
                        <Grid container={true} spacing={24}>
                            <Grid item={true} xs={4}>
                                <FormControl margin="normal" required={true} fullWidth={true}>
                                    <Input id="title"
                                        name="title"
                                        value={this.props.baseSurvey && this.props.baseSurvey.title || ''}
                                        onChange={this.handleTitleChange}
                                        disabled={status}
                                        placeholder="Add Survey Name"
                                        fullWidth={true}
                                    />
                                    {this.props.surveyValidation.isTitleValid && <span className="errorMessage">Title field is required</span>}
                                </FormControl >
                            </Grid>
                            <Grid item={true} xs={2}>
                                <FormControl margin="normal" required={true} fullWidth={true}>
                                <Select
                                        value= {this.props.baseSurvey && this.props.baseSurvey.year || ''}
                                        displayEmpty={true}
                                        onChange={this.handleYearChange}
                                        disabled={status}
                                        inputProps={{
                                            name: min.toString(),
                                            id: min.toString()
                                        }}
                                    >
                                        <MenuItem value='' key="">Year</MenuItem>
                                        {this.getMenuItem()}
                                    </Select>
                                    {this.props.surveyValidation.isYearValid && <span className="errorMessage">Year field is required</span>}
                                </FormControl >
                            </Grid>
                            <Grid item={true} xs={2}>
                                <FormControl margin="normal" required={true} fullWidth={true}>
                                    <Select
                                        value={this.props.baseSurvey && this.props.baseSurvey.surveyType || ''}
                                        displayEmpty={true}
                                        onChange={this.handleSurveyTypeChange}
                                        inputProps={{
                                            name: min.toString(),
                                            id: min.toString()
                                        }}
                                    >
                                    <MenuItem value='' key="">Survey Type</MenuItem>
                                    {this.props.roleId === 2 ? ""
                                        :
                                        <MenuItem value='1' key="1">Global Survey</MenuItem>
                                    }
                                    <MenuItem value='2' key="2">Regional Survey</MenuItem>
                                </Select>
                                {this.props.surveyValidation.isSurveyTypeValid && <span className="errorMessage">Survey Type is required</span>}
                            </FormControl >
                        </Grid>
                        </Grid>
                        <Grid container={true} spacing={24}>
                            <Grid item={true} sm={6} >
                                <FormControl margin="normal" fullWidth={true}>
                                    <TextField
                                        id="description"
                                        name="description"
                                        value={this.props.baseSurvey && this.props.baseSurvey.description || ''}
                                        onChange={this.handleDescriptionChange}
                                        disabled={status}
                                        label=""
                                        placeholder="Add Description"
                                        helperText=""
                                        margin="normal"
                                    />
                                    {this.props.surveyValidation.isDescriptionValid && <span className="errorMessage">Description field is required</span>}
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid container={true} spacing={24} alignItems={"center"}>
                            <Grid item={true} sm={2} >
                                <InputLabel htmlFor="deadlineDate">Survey End Date:</InputLabel>
                            </Grid>
                            <Grid item={true} sm={2} >
                                <FormControl margin="normal" fullWidth={true} className="deadlineFormcontrol">
                                    <TextField
                                        id="deadlineDate"
                                        name="deadlineDate"
                                        type="date"
                                        defaultValue={validationDate ? validationDate.toString() : ''}
                                        value={validationDate ? validationDate.toString() : ''}
                                        onChange={this.handleDeadlineDateChange}
                                        autoFocus={false}
                                        margin="normal"
                                        variant="outlined"
                                    />
                                    {this.props.surveyValidation.isDdeadlineDateValid && <span className="errorMessage">Survey End Date field is required</span>}
                                    {this.props.surveyValidation.isDdeadlineMinDateValid && <span className="errorMessage">Survey End Date can not be in past</span>}
                                </FormControl>
                            </Grid>
                            {status && !this.props.surveyValidation.isDdeadlineMinDateValid &&
                                <Grid item={true} sm={3} >

                                    <Button type="button" className="btn-blue" variant="outlined" size="medium" onClick={this.updateSurveyEndDate} >
                                        Update Survey End Date
                                    </Button>
                                </Grid>
                            }
                        </Grid>
                    </div>
                }
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/surveys/SurveyDetailsComponent.tsx